const KNOWLEDGE_BASE_V3_1 = 'KnowledgeBase:V3.1';
export const isUngatedForKnowledgeBaseV3_1 = gates => gates.includes(KNOWLEDGE_BASE_V3_1);